import CustomerSection from './Components/customer-section/index.section'
import FaqSection from './Components/faq-section/index.section'
import FooterSection from './Components/footer-section/index.section'
import HeaderSection from './Components/header-section/index.section'
import CommentsSection from './Components/comments-section/index.section'
import CartContextProvider from './providers/CartContextProvider'
import { NextUIProvider } from "@nextui-org/react";
import FavoriteContextProvider from './providers/FavoriteContextProvider'
import AuthContextProvider from './providers/AuthContextProvider'
import { BaseAPI } from './config/axios'
import axios from 'axios'
import BackToTopButton from './Components/BackToTop'
import GlobalDataProvider from './providers/GlobalDataProvider'
import React, { useState } from 'react'
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom'
import Main from './pages/Main';
import SignIn from './pages/auth/login'
import Contact from './pages/contact'
import AboutUs from './pages/about-us'
import Favorite from './pages/favorite'
import Search from './pages/search'
import CapillaryGuidance from './pages/CapillaryGuidance'
import Custom404 from './pages/404'
import Shipping from './pages/checkout/shipping'
import Cart from './pages/checkout/cart'
import Artists from './pages/artists'
import Artist from './pages/artists/[id]'
import Blogs from './pages/blogs'
import Blog from './pages/blogs/[id]'
import Categories from './pages/categories'
import Category from './pages/categories/[id]'
import Paintings from './pages/painting'
import Paint from './pages/painting/[id]'
import { adminRoutes } from './lib/adminRoutes'
import Vendor from './pages/admin'
import { profileRoutes } from './lib/profileRoutes'
import Profile from './pages/profile'
import Products from './pages/products/Products'
import Product from './pages/products/Product'
import Layout from './pages/SchemaLayout'

axios.defaults.baseURL = BaseAPI
export default function App() {
    const location = useLocation();
    const navigate = useNavigate();
    const [is404, setIs404] = useState(false)

    const routesWithoutNavFoot = [
        '/about-us',
        '/contact',
        '/favorite',
        '/checkout/cart',
        '/checkout/shipping',
        '/auth/login',
        '/search',
        '/capillary-guidance'
    ];

    // Check if the current path is one of the defined routes
    const isWithoutNavbarFooter = routesWithoutNavFoot.includes(location.pathname) ||
        location.pathname.startsWith('/admin') ||
        location.pathname.startsWith('/profile') || is404

    const RouteWrapper = ({ Component }) => {
        if (Component.name === 'Custom404')
            setIs404(true)
        else setIs404(false)
        return <Component />;
    };


    return (
        <>
            <NextUIProvider navigate={navigate}>
                <AuthContextProvider>
                    <CartContextProvider>
                        <FavoriteContextProvider>
                            <GlobalDataProvider>
                                <main>
                                    <HeaderSection />
                                    <Layout>
                                        <Routes>
                                            <Route path="/product/:slug" element={<RouteWrapper Component={Paint} />} />
                                            <Route path="/product" element={<RouteWrapper Component={Paintings} />} />
                                            <Route path="/categories/:slug" element={<RouteWrapper Component={Category} />} />
                                            <Route path="/categories" element={<RouteWrapper Component={Categories} />} />
                                            <Route path="/blogs/:slug" element={<RouteWrapper Component={Blog} />} />
                                            <Route path="/blogs" element={<RouteWrapper Component={Blogs} />} />
                                            {adminRoutes.map((route) => (
                                                <Route
                                                    key={route.link}
                                                    path={`/admin/${route.link}`}
                                                    element={<RouteWrapper Component={() => <Vendor vendor={route.link} />} />}
                                                />
                                            ))}
                                            {profileRoutes.map((route) => (
                                                <Route
                                                    key={route.link}
                                                    path={`/profile/${route.link}`}
                                                    element={<RouteWrapper Component={() => <Profile route={route.link} />} />}
                                                />
                                            ))}
                                            <Route path="/ready-product/:slug" element={<RouteWrapper Component={Product} />} />
                                            <Route path="/ready-product" element={<RouteWrapper Component={Products} />} />
                                            <Route path="/artists/:slug" element={<RouteWrapper Component={Artist} />} />
                                            <Route path="/artists" element={<RouteWrapper Component={Artists} />} />
                                            <Route path="/checkout/cart" element={<RouteWrapper Component={Cart} />} />
                                            <Route path="/checkout/shipping" element={<RouteWrapper Component={Shipping} />} />
                                            <Route path="/capillary-guidance" element={<RouteWrapper Component={CapillaryGuidance} />} />
                                            <Route path="/search" element={<RouteWrapper Component={Search} />} />
                                            <Route path="/favorite" element={<RouteWrapper Component={Favorite} />} />
                                            <Route path="/about-us" element={<RouteWrapper Component={AboutUs} />} />
                                            <Route path="/contact" element={<RouteWrapper Component={Contact} />} />
                                            <Route path="/auth/login" element={<RouteWrapper Component={SignIn} />} />
                                            <Route path="/" element={<RouteWrapper Component={Main} />} />
                                            <Route path="*" element={<RouteWrapper Component={Custom404} />} />
                                        </Routes>
                                    </Layout>
                                    <BackToTopButton />
                                    {!isWithoutNavbarFooter && <>
                                        <CommentsSection />
                                        <FaqSection />
                                        <CustomerSection />
                                    </>}
                                    <FooterSection />
                                </main>
                            </GlobalDataProvider>
                        </FavoriteContextProvider>
                    </CartContextProvider>
                </AuthContextProvider>
            </NextUIProvider>
        </>
    )
}
